/*
 * WCAG 1.4.13 (Content on Hover or Focus) — make the desktop navigation
 * dropdowns and mega-menus dismissible.
 *
 * The theme reveals these panels on hover and on keyboard focus (see the Menu
 * class in theme.min.js) but has no Escape handler, so a keyboard user who
 * focuses into a menu cannot dismiss it without tabbing all the way through it.
 *
 * On Escape while focus is inside a `.site-nav--has-dropdown` item, we add a
 * `nav-dropdown--force-closed` class (hidden via component-nav-a11y.css, which
 * overrides both the :hover reveal and the JS-set inline display:block) and
 * return focus to the top-level trigger. The class is removed as soon as the
 * pointer or focus leaves the item, so normal hover/focus reveal resumes.
 */
(function () {
  var FORCE_CLOSED = 'nav-dropdown--force-closed';

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var focused = document.activeElement;
    if (!focused || typeof focused.closest !== 'function') return;

    var item = focused.closest('.site-nav--has-dropdown');
    if (!item) return;

    event.stopPropagation();

    var trigger = item.querySelector(':scope > a.site-nav__link, :scope > .site-nav__link');

    // Already dismissed (e.g. Escape pressed twice) — just keep focus on the trigger.
    if (item.classList.contains(FORCE_CLOSED)) {
      if (trigger) trigger.focus();
      return;
    }

    item.classList.add(FORCE_CLOSED);
    if (trigger) trigger.focus();

    function reset() {
      item.classList.remove(FORCE_CLOSED);
      item.removeEventListener('focusout', onFocusOut);
      item.removeEventListener('mouseleave', reset);
    }
    function onFocusOut(e) {
      if (!item.contains(e.relatedTarget)) reset();
    }

    item.addEventListener('focusout', onFocusOut);
    item.addEventListener('mouseleave', reset);
  });
})();
